<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-book-open"></i></div>
      <div>
        Cahier de note par matière
        <div class="page-title-subheading">Notes d'une matière, tous élèves</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <ng-select  (change)="loadCourses($event)" >
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la matière</label>
        <ng-select  (change)="loadCompositions1($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let c of courses" [value]="c?.id">{{c?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <ng-select  [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
</div>
<div class="text-center mb-3">
    <button *ngIf="data.length!=0" [disabled]="loading" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
        Exporter le cahier de note en PDF <app-loading [isVisible]="loading"></app-loading> </button>
</div>
<div class="container bg-white">
  <p>{{data!.length}} élément(s)</p>
  <div class="table-responsive">
  <table class="table table-sm table-bordered table-striped">
    <thead>
        <th>Elèves</th>
        <th class="text-center"  *ngFor="let c of compositions">
            <span>{{c.label}}</span>
            <!-- <br>
            <span>{{c.created_at | date:"dd-MM-yyyy"}}</span> -->
        </th>
    </thead>
    <tbody>
        <tr *ngFor="let d of data">
            <td>{{d.student}}</td>
            <td class="text-center" *ngFor="let n of d.notes">{{n}}</td>
        </tr>
    </tbody>
  </table>
  </div>
</div>


<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>